import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PerformanceService } from "@app/performance/performance.service";
import { optionsUsers, optionSla, optionNoOfHits, optionThroughput } from "@app/_constants";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-compare-results",
  templateUrl: "./compare-results.component.html",
  styleUrls: ["./compare-results.component.less"],
  providers: [DatePipe],
})
export class CompareResultsComponent implements OnInit {
  options: any = optionsUsers;
  optionsSla: any = optionSla;
  optionNoOfHits: any = optionNoOfHits;
  optionThroughput: any = optionThroughput;
  lineChartType = "line";

  results = [];
  labels: any = [];
  dataHitsPSec: Array<any> = [
    {
      data: new Array(),
    },
  ];
  ninetyPercentile: Array<any> = [
    {
      data: new Array(),
    },
  ];

  actualSla: Array<any> = [
    {
      data: new Array(),
    },
  ];

  throughput: Array<any> = [
    {
      data: new Array(),
    },
  ];

  constructor(private route: ActivatedRoute, private performanceService: PerformanceService, private datepipe: DatePipe) {}

  ngOnInit() {
   this.results = window.history.state.data;
   this.drawChart(this.results);
  }

  drawChart(data: any) {
    this.labels = data.map((item: { performanceRequest: { startTime: any } }) =>
      this.datepipe.transform(item.performanceRequest.startTime, "short")
    );

    let graphData = data.map((item: { performanceEndPointDtos: any }) => item.performanceEndPointDtos);
    this.ninetyPercentile = graphData[0].map((_item: any, index: number) => {
      return {
        label: graphData[0][index].name,
        fill: false,
        data: graphData.map((innerItem: any, i: number) => graphData[i][index]["ninetyPercentile"]),
      };
    });

    this.actualSla = graphData[0].map((_item: any, index: number) => {
      return {
        label: graphData[0][index].name,
        fill: false,
        data: graphData.map((_innerItem: any, i: number) => graphData[i][index]["actualSla"]),
      };
    });

    this.dataHitsPSec = graphData[0].map((_item: any, index: number) => {
      return {
        label: graphData[0][index].name,
        fill: false,
        data: graphData.map((_innerItem: any, i: number) => graphData[i][index]["noOfHits"]),
      };
    });

    this.throughput = graphData[0].map((_item: any, index: number) => {
      return {
        label: graphData[0][index].name,
        fill: false,
        data: graphData.map((_innerItem: any, i: number) => graphData[i][index]["throughput"]),
      };
    });
  }
}
